
import { Link as RouterLink } from 'react-router-dom';
import { ReactNode } from 'react';

import { Grid, Typography, Link, Paper, CardContent, } from '@mui/material';
import { Login, } from '@mui/icons-material'

import loginBG from '../assets/images/bg-login.png';

const backToSiteUrl = import.meta.env.VITE_BACK_TO_SITE_URL;

/* PROPS INTERFACE */
type AuthLayoutProps = {
    children: ReactNode; // Esto define el tipo de `children`
    title: string;
    linkTo: string;
};


//const backgroundImage = `url(https://source.unsplash.com/random?blue)`


export const RegisterLayout = ({ children }: AuthLayoutProps) => {
    return (
        /* contenedor principal */
        <Grid
            container
            component="main"
            alignItems="center"
            justifyContent="center"
            sx={{
                padding: "10px",
                // backgroundColor: "#04082B"
            }}
        >

            <Grid item
                display={'flex'}
                xs={12}
                alignItems={'top'}
                sx={{
                    height: "5vh",
                    //backgroundImage: `url(https://source.unsplash.com/random?night)`,
                    //backgroundImage: `url(${loginBG})`,


                }}>


                <Login sx={{
                    ml: 10,
                    mr: 1,
                    color: 'primary',
                    mt: 1
                }}
                />

                <Typography
                    variant="h6"
                    mt={1}
                    noWrap
                    component={RouterLink}
                    to={backToSiteUrl}
                    sx={{
                        /* fontFamily: 'monospace',
                        fontWeight: 700, */
                        fontFamily: 'Montserrat',
                        fontWeight: 700,
                        letterSpacing: '.1rem',
                        color: 'primary',
                        textDecoration: 'none',
                        fontSize: '1rem'
                    }}
                >
                    Volver a inicio
                </Typography>

            </Grid>

            <Grid item xs={12} md={8} sx={{ p: { xs: 0, md: 5 } }}>
                {/* contenedor del cuadro blanco */}
                <Paper sx={{
                    borderRadius: 3,
                    position: 'relative',
                    overflow: 'visible',
                    flexGrow: 1,

                }} elevation={10}>

                    <Grid component={Paper} elevation={6} container alignItems={'center'} justifyContent={'center'}
                        sx={{
                            backgroundColor: "primary.main",
                            borderRadius: 2,
                            width: '90%',
                            py: 5,
                            transform: 'translateY(20%)',
                            margin: 'auto',
                        }}
                    >
                        {/* Typography para el texto del título */}
                        <Grid item xs={12} textAlign={'center'}>
                            <Typography
                                variant='h4'
                                color={"white"}
                                sx={{

                                    fontWeight: 700,
                                    display: 'inline',
                                    // fontSize: { xs: '2rem', lg: '2rem' },
                                    fontFamily: "'Montserrat', cursive",
                                }}
                            >
                                Pre-registro de estudiantes
                            </Typography>
                        </Grid>

                        <Grid item textAlign={'center'} mt={1}>
                            <Typography
                                variant='body1'
                                color={"white"}
                                sx={{

                                    display: 'inline',
                                    fontSize: { xs: '1rem', lg: '1.2rem' },
                                    fontFamily: "'Montserrat', cursive",
                                }}
                            >
                                Por favor, ingrese sus datos para hacer su solicitud

                            </Typography>
                        </Grid>

                        {/* <SocialLoginButtons /> */} {/* Colocamos los botones de redes sociales aquí */}

                    </Grid>

                    <CardContent sx={{
                        px: { xs: 2, md: 3, lg: 4 },
                        mt: 10,
                        pt: 0,
                        pb: 2, // Asegúrate de ajustar este padding para que todo encaje bien
                    }}>


                        {children}

                    </CardContent>

                </Paper>
            </Grid>


        </Grid>

    )
}
